module.exports = "/images/cardButton.svg?47e824b998d97a4c97b0c7b8774b696b";